var map = {
	"./nav_bt_3_ns.png": "8Nj3",
	"./nav_bt_3_s.png": "PPn+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "svST";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st ^\.\/nav_bt_3_.*\.png$
// module id = svST
// module chunks = 0